import { isSsr } from './general';

export const getAuthorizationToken = () => (!isSsr ? window.THDCustomer?.default?.token || '' : '');

export const isLoggedIn = () => window.THDCustomer?.default?.isLoggedIn || false;

export const isB2BUser = () => window.THDCustomer?.default?.isB2BCustomer || false;

export const isInStore = () => window?.Localizer?.status?.isUserInStore() === true;
